// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__mainFont_c74a44', '__mainFont_Fallback_c74a44'"},"className":"__className_c74a44","variable":"__variable_c74a44"};